export const GOOGLE_OAUTH_PATH = '/api/oauth-token/v1/authorization/google';
export const GSUITE_OAUTH_PATH = '/api/oauth-token/v1/authorization/googleworkspace';
export const GSUITE_MARKETPLACE_URL = 'https://workspace.google.com/marketplace';
